<template>
  <b-card no-body class="p-3">
    <template #header>
      <b-card-sub-title
        class="my-0"
        v-bind:class="{
          'card-subtitle-doom-yoga': client_name == 'DY',
          'card-subtitle-irish-date': client_name == 'MID',
        }"
        >Payment Settings</b-card-sub-title
      >
    </template>

    <b-card-body class="pt-0">
      <b-row>
        <b-col md="6">
          <b-form-group
            :class="{
              'form-group-vselect-doomyoga': client_name == 'DY',
              'form-group-vselect-mid': client_name == 'MID',
            }"
            label="Price per Session"
            label-for="price_per_session"
            :price_per_session="price_per_session"
            :label-class="{
              'form-label-doomyoga': client_name == 'DY',
              'form-label-mid': client_name == 'MID',
            }"
          >
            <p
              :class="{
                'error_validation_message_p_dy mx-0': client_name == 'DY',
                error_validation_message_p_mid: client_name == 'MID',
              }"
              v-if="invalid_session_price"
            >
              Please select session price
            </p>
            <v-select
              :options="price_types"
              name="price_per_session"
              title="price_per_session"
              v-model="_price_per_session"
              :reduce="(item) => item.code"
              placeholder="Select price per session"
              required
            ></v-select
          ></b-form-group>
        </b-col>

        <b-col
          md="6"
          v-if="
            price_per_session != null &&
            price_per_session != '' &&
            (price_per_session.code == 'fixed' || price_per_session == 'fixed')
          "
        >
          <b-form-group
            label="Amount"
            label-for="amount"
            :amount="amount"
            :label-class="{
              'form-label-doomyoga': client_name == 'DY',
              'form-label-mid': client_name == 'MID',
            }"
          >
            <b-input-group class="w-100 inputGroupPayment">
              <b-input-group-prepend class="p-2">
                <img
                  v-if="client_name == 'DY'"
                  class="sessionIconImg"
                  src="@/assets/images/doom-yoga/amount-icon.png"
                  alt=""
                  width="12px"
                  height="18px"
                />
                <img
                  v-if="client_name == 'MID'"
                  class="sessionIconImg"
                  src="@/assets/images/my-irish-date/amount-icon.png"
                  alt=""
                  width="12px"
                  height="18px"
                />
              </b-input-group-prepend>
              <b-form-input
                v-bind:class="{
                  'form-control-doomyoga': client_name == 'DY',
                  'form-control-mid': client_name == 'MID',
                }"
                type="number"
                min="0"
                v-model="_amount"
                required
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>


<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

export default {
  name: "EventPayment",
  props: [
    "price_per_session",
    "amount",
    "invalid_session_price",
    "client_name",
  ],

  components: {},
  data() {
    return {
      price_types: [
        { label: "Fixed price", code: "fixed" },
        { label: "No fees", code: "no_fees" },
      ],
      selected_price_per_session: "",
    };
  },
  mounted() {
    // console.log(this.price_per_session);
  },
  computed: {
    _price_per_session: {
      get() {
        return this.price_per_session;
      },
      set(value) {
        // console.log(value);
        this.$emit("update:price_per_session", value);
        this._amount = "";
      },
    },
    _amount: {
      get() {
        return this.amount;
      },
      set(value) {
        this.$emit("update:amount", value);
      },
    },
  },
  methods: {},
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/components/events/Payment.vue